import { createReducer } from 'typesafe-actions'
import { setAuthToken, unsetAuthToken } from '../actions'
import { ActionTypes } from '../types'

export type AppState = {
  authToken: string | null
}

export const initialState = {
  authToken: null,
}

export const app = createReducer<AppState, ActionTypes>(initialState)
  .handleAction(setAuthToken, (state, { payload }) => ({
    ...state,
    authToken: payload,
  }))
  .handleAction(unsetAuthToken, (state) => ({
    ...state,
    authToken: null,
  }))
